const MASK_SELECTOR = '.v-modal, .black-bg, .van-overlay'

let overlay = false
let observer = null
let initialized = false

function setOverlay(val) {
  overlay = val
}

function detect() {
  if (typeof document === 'undefined') return
  setOverlay(!!document.querySelector(MASK_SELECTOR))
}

function init() {
  if (initialized || typeof document === 'undefined') return
  initialized = true
  detect()
  observer = new MutationObserver(() => detect())
  observer.observe(document.body, { childList: true, subtree: true })
}

function isOverlayActive() {
  if (!initialized) init()
  // 每次查询时同步 re-detect，防止 SPA 路由切换后 MutationObserver 回调尚未执行导致状态残留
  detect()
  return overlay
}

export default { init, isOverlayActive }
